import { getIsAttachmentMessageTemplateHeader } from 'apps/messenger/utils/getIsAttachmentMessageTemplateHeader'
import {
  MessengerMessageTemplateDraft,
  MessengerMessageTemplateHeaderType,
} from 'shared/api/requests/messenger/schemas'

export function isMessageTemplateHeaderValid(
  header: MessengerMessageTemplateDraft['header'],
): boolean {
  if (!Array.isArray(header) && header?.type === MessengerMessageTemplateHeaderType.TEXT) {
    return !isEmptyOrUndefined(header.text)
  } else if (getIsAttachmentMessageTemplateHeader(header)) {
    return !isEmptyOrUndefined(header.url)
  } else {
    return false
  }
}

const isEmptyOrUndefined = (text: string | undefined) => text === undefined || text.trim() === ''
